module.exports = __webpack_public_path__ + "media/images/img_about_01-466e0f2f396586ac13885ba86c09583b.png";